
























import Vue from 'vue';

import Input from '../common/Input/Input.vue';

export default Vue.extend({
  components: {
    Input,
  },
  props: {
    requiredSize: {
      type: Number,
    },
    requiredDuration: {
      type: Number,
    },
  },
  data(): {
    size: number;
    duration: number;
  } {
    return {
      size: this.requiredSize,
      duration: this.requiredDuration,
    };
  },
  methods: {
    updateSize() {
      this.$emit('update:requiredSize', this.size ? +this.size : undefined);
    },
    updateDuration() {
      this.$emit(
        'update:requiredDuration',
        this.duration ? +this.duration : undefined,
      );
    },
  },
});
